<script lang="ts">
  import { _ } from 'svelte-i18n';

  import { AppState } from '../../etc/stores';
  import { pluralizeI18n } from '../../etc/utils';
  import { replaceVariables } from '../../i18n';
  import flagKeys from '../../etc/flagKeys';
  import Alert from '../alert/Alert.svelte';

  $: expirableCoinsIsActive = $AppState.featureFlags.includes(flagKeys.EXPIRABLE_COINS);
  $: coinsExpiringSoon = $AppState.customer.wallet?.coinsExpiringSoon?.toFixed(2);

  const t = (text: string, values: Record<string, any> = {}) => {
    return replaceVariables($_(`coins-expiring-soon-disclaimer.${text}`), values);
  };
</script>

{#if expirableCoinsIsActive && parseFloat(coinsExpiringSoon) > 0}
<div class="twm-coins-expiring-soon-disclaimer">
  <Alert
    title={t(pluralizeI18n('coins', coinsExpiringSoon), { COINS: coinsExpiringSoon })}
    description={t('description')}
  />
</div>
{/if}
